import React, { PureComponent } from "react";
import UserGreeting from "../../main/UserGreeting";
import UserLogin from "./components/UserLogIn";
import KBELogo from "../img/kbe-Logo-66454.png";
import SimpleBottomNavigation from "../../main/components/SimpleBottomNav";
import AppConfig from "../../../config/appconfig.json";

export default class LogIn extends PureComponent {
  constructor(props) {
    super(props);

    let isAgreementAccepted = false;
    let kbeAgreement = this.getAgreement();
    if (kbeAgreement != null) isAgreementAccepted = kbeAgreement === "true";

    this.state = {
      username: localStorage.getItem("usernameLogin"),
      isAgreementAccepted: isAgreementAccepted,
      custSystemList: []
    };

    this.retrieveCustomerSystem = this.retrieveCustomerSystem.bind(this);

    this.retrieveCustomerSystem();
  }

  getAgreement() {
    const kbeAgreement = localStorage.getItem("kbeAgreement");
    return kbeAgreement;
  }

  retrieveCustomerSystem() {
    const kbeSid = localStorage.getItem("kbeSid");
    if (kbeSid) {
      let isretrieveCustomerSystemFailed = false;
      // Call Back-End Services
      fetch(
        `${AppConfig.BACK_END_URL}/APIClient/RetrieveCustomerSystem?Sid=` +
        kbeSid
      )
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isretrieveCustomerSystemFailed = true;
          }
          return response.json();
        })
        .then(json => {
          if (isretrieveCustomerSystemFailed) {
            const custSys = localStorage.getItem("RetrieveCustomerSystem");
            if (custSys) {
              const respObj = JSON.parse(custSys);
              this.setState({ custSystemList: respObj });
            }
          } else {
            const respObj = JSON.parse(json);
            // console.log(respObj);
            this.setState({ custSystemList: respObj });
            localStorage.setItem("RetrieveCustomerSystem", JSON.stringify(respObj));
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when retrieving customer systems. Please try again."
          );
          const custSys = localStorage.getItem("RetrieveCustomerSystem");
          if (custSys) {
            const respObj = JSON.parse(custSys);
            this.setState({ custSystemList: respObj });
          }
        });
    }
  }

  render() {
    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={KBELogo} alt="logo" />
            </div>
            {this.state.username != null ? (
              <div>
                <UserGreeting
                  username={this.state.username}
                  isAgreementAccepted={this.state.isAgreementAccepted}
                  custSystemList={this.state.custSystemList}
                />
                <SimpleBottomNavigation
                  disabled={!this.state.isAgreementAccepted}
                />
              </div>
            ) : (
                <UserLogin />
              )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/log_in/LogIn.js